<template>
	<section class="contact" id="contact">
    <div class="contact--wrapper">
      <div class="contact--container">
        <p>
          Gostaria de receber mais informações sobre o benefício?
          Deixe seu e-mail abaixo:
        </p>
        <validation-observer
          class="contact--form-container"
          ref="observer"
        >
          <div
            v-if="submitted && contact_name"
            class="submitted-message"
          >
            <p>Olá, <span>{{ contact_name }}</span></p>
            <p>Recebemos o seu cadastro e ficamos felizes pelo seu interesse em nosso plano de benefícios Empiricus Pass Empresas</p>

            <p>Nossa central de atendimento recebeu os seus dados para contato e, em breve, você receberá um retorno com os próximos passos.</p>

            <SVGLoader class="submitted--icon" src="/static/svg/checked.svg" />

            <SVGLoader src="/static/svg/"/>
          </div>
          <form
            v-else
            class="contact--form"
            @submit.prevent="submit"
            @keypress.enter="submit"
          >
            <p
              v-if="error.length > 0"
              class="form-error"
            >
              {{error}}
            </p>

            <validation-provider
              v-slot="{ errors }"
              name="Nome"
              rules="required"
            >
              <v-text-field
                v-model="name"
                :error-messages="errors"
                placeholder="Digite seu nome"
                required
              ></v-text-field>
            </validation-provider>
            <validation-provider
              v-slot="{ errors }"
              name="Empresa"
              rules="required"
            >
              <v-text-field
                v-model="company"
                :error-messages="errors"
                placeholder="Nome da empresa"
                required
              ></v-text-field>
            </validation-provider>
            <validation-provider
              v-slot="{ errors }"
              name="E-mail"
              rules="required|email"
            >
              <v-text-field
                v-model="email"
                :error-messages="errors"
                placeholder="Coloque seu melhor e-mail"
                required
              ></v-text-field>
            </validation-provider>

            <v-btn
              class="contact--form-submit-btn"
              type="submit"
            >
              <clip-loader
                v-if="loading"
                :loading="loading"
                color="#FFFFFF"
                size="20px"
              />
              <span v-else> Entrar</span>
            </v-btn>
            <span class="contact--form-disclaimer">
              * Ao clicar no botão, você concorda com nossos
              <a href="https://www.empiricus.com.br/termos-de-uso/" target="_blank">Termos de Uso </a> e
              <a href="https://www.empiricus.com.br/politica-de-privacidade/" target="_blank">Política de Privacidade</a>,
              incluindo o uso de cookies e envio de comunicações.
            </span>
          </form>
        </validation-observer>


      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';
import { getCookie, setCookie } from '@/helpers/cookie'
import { required, email } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
import SVGLoader from '@/components/SvgLoader'

setInteractionMode('eager')

extend('required', {
  ...required,
  message: '{_field_} não pode ser vazio.',
})

extend('email', {
  ...email,
  message: 'Digite um e-mail válido.',
})

export default {
  components: {
    ClipLoader,
    ValidationProvider,
    ValidationObserver,
    SVGLoader
  },
  data: () => ({
    name: '',
    email: '',
    company: '',
    loading: false,
    error: '',
    submitted: false,
    contact_name: ''
  }),
  created () {
    this.getCookies()
  },
  methods: {
    async submit () {
      this.loading = true
      const valid = await this.$refs.observer.validate()
      if (valid) {
        const currentDate = new Date().toLocaleDateString()
        const body = new URLSearchParams()
        body.append('emailAddress', this.email)
        body.append('listCode', 'EHL_PASSB2B')
        body.append('sourceId', 'LP-PASSB2B-X-X-X-X')
        body.append('name', this.name)
        body.append('createdAt', currentDate)
        body.append('phone', '---')
        body.append('company', this.company)
        try {
          const response = await axios.post('https://ws.empiricus.com.br/subscribe', body)
          if (response.status >= 400) {
            throw new Error(response.data.message)
          }
          setCookie(this.name)
          this.getCookies()
          this.loading = false
        } catch (error) {
          this.loading = false
          this.error = 'Aparenemente ocorreu um erro. Tente novamente.'
        }
      }
    },
    getCookies() {
      const { contact_name, submitted } = getCookie()
      this.contact_name = contact_name
      this.submitted = submitted
    }
  },
}
</script>

<style lang="scss">
.contact {
  background-color: var(--default-black);
  display: flex;
  justify-content: center;
  width: 100%;
}

.contact--wrapper {
  display: flex;
  justify-content: center;
  max-width: 1920px;
  width: 100%;
}

.contact--container {
  padding: 40px 16px;
  max-width: 1256px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media only screen and (min-width: 600px) {
    padding: 80px 0;
  }

  p {
    color: var(--white);
    font-family: var(--dm-sans-bold);
    font-size: 1.4375rem;
    line-height: 26px;
    margin-bottom: 30px !important;
    max-width: 308px;
    text-align: center;

    @media only screen and (min-width: 600px) {
      font-size: 1.6989rem;
      line-height: 31px;
      margin-bottom: 50px !important;
      max-width: 590px;
    }

    @media only screen and (min-width: 1024px) {
      font-size: 1.9375rem;
      line-height: 35px;
      max-width: 670px;
    }

    @media only screen and (min-width: 1440px) {
      font-size: 2.7959rem;
      line-height: 50px;
      margin-bottom: 40px !important;
      max-width: 970px;
    }
  }

  .submitted-message {
    background: var(--default-black-faq);
    border-radius: 4px;
    padding: 16px;
    display: flex;
    align-items: center;
    flex-direction: column;

    p:first-child {
      font-family: var(--dm-sans-medium);
    }

    span {
      text-decoration: underline;
    }

    p {
      font-family: var(--dm-sans-regular);
      font-size: 1rem;
      line-height: 20px;
      margin: 0 !important;
      margin-bottom: 8px !important;
      text-align: left;
      width: 100%;
    }

    .submitted--icon {
      margin-top: 16px;
      svg {
        height: 26px;
        width: 26px;
      }
    }
  }


  .contact--form-container {
    max-width: 598px;
    width: 100%;

    a {
      color: var(--light-grey);
      text-decoration: underline;
    }
  }

  form {
    background-color: var(--neutral-black-faq);
    border-radius: 4px;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.2);
    padding: 20px;
    max-width: 598px;
    width: 100%;

    @media only screen and (min-width: 600px) {
      padding: 40px;
    }
  }

  .form-error {
    background: var(--red);
    border-radius: 4px;
    color: var(--white);
    font-family: var(--dm-sans-medium);
    font-size: .875rem;
    letter-spacing: 0.5px;
    margin-bottom: 16px !important;
    text-align: left;
    padding-left: 12px;
  }

  .v-text-field {
    padding-top: 0 !important;
    margin-top: 4px !important;
  }

  .v-input {
    input {
      background: white !important;
      border: 2px solid var(--grey-day-030) !important;
      border-radius: 4px;
      color: var(--grey) !important;
      font-family: var(--dm-sans-regular) !important;
      font-size: .75rem !important;
      line-height: 16px !important;
      min-height: 40px;
      padding: 12px !important;
      width: 100% !important;

      @media only screen and (min-width: 600px) {
        font-size: .875rem !important;
        line-height: 19px !important;
        min-height: 44px;
      }

      @media only screen and (min-width: 1024px) {
        font-size: 1rem !important;
        line-height: 21px !important;
        min-height: 48px;
      }
    }
  }

  .contact--form-submit-btn {
    background-color: var(--red) !important;
    border-radius: 4px;
    color: var(--white) !important;
    font-family: var(--dm-sans-regular) !important;
    font-size: .75rem !important;
    height: 40px !important;
    line-height: 16px;
    margin-top: 4px !important;
    margin-bottom: 12px !important;
    text-transform: capitalize !important;
    width: 100% !important;

    @media only screen and (min-width: 600px) {
      font-size: .875rem !important;
      height: 44px !important;
      line-height: 19px;
    }

    @media only screen and (min-width: 1024px) {
      font-size: .875rem !important;
      height: 40px !important;
      line-height: 19px;
    }

    @media only screen and (min-width: 1440px) {
      font-size: 1rem !important;
      height: 48px !important;
      line-height: 21px;
    }
  }

  .contact--form-disclaimer {
    color: var(--light-grey);
    font-family: var(--dm-sans-regular);
    font-size: .75rem;
    line-height: 17px;

    @media only screen and (min-width: 600px) {
      font-size: .875rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Section/Section6.vue